var O, ee;
function Se() {
  if (ee) return O;
  ee = 1;
  var e = Object.defineProperty, i = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, o = Object.prototype.hasOwnProperty, a = (n, t) => {
    for (var l in t)
      e(n, l, { get: t[l], enumerable: !0 });
  }, r = (n, t, l, h) => {
    if (t && typeof t == "object" || typeof t == "function")
      for (let f of s(t))
        !o.call(n, f) && f !== l && e(n, f, { get: () => t[f], enumerable: !(h = i(t, f)) || h.enumerable });
    return n;
  }, c = (n) => r(e({}, "__esModule", { value: !0 }), n), u = {};
  a(u, {
    XmlCdata: () => F,
    XmlComment: () => R,
    XmlDeclaration: () => V,
    XmlDocument: () => G,
    XmlDocumentType: () => H,
    XmlElement: () => D,
    XmlError: () => K,
    XmlNode: () => m,
    XmlProcessingInstruction: () => j,
    XmlText: () => _,
    parseXml: () => Ce
  }), O = c(u);
  var p = "", g = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, w = class {
    constructor(n) {
      if (this.k = this.u(n, !0), this.d = 0, this.length = n.length, this.l = this.k !== this.length, this.h = n, this.l) {
        let t = [];
        for (let l = 0, h = 0; h < this.k; ++h)
          t[h] = l, l += n.codePointAt(l) > 65535 ? 2 : 1;
        this.A = t;
      }
    }
    /**
     * Whether the current character index is at the end of the input string.
     */
    get B() {
      return this.d >= this.k;
    }
    // -- Protected Methods ------------------------------------------------------
    /**
     * Returns the number of characters in the given string, which may differ from
     * the byte length if the string contains multibyte characters.
     */
    u(n, t = this.l) {
      return t ? n.replace(g, "_").length : n.length;
    }
    // -- Public Methods ---------------------------------------------------------
    /**
     * Advances the scanner by the given number of characters, stopping if the end
     * of the string is reached.
     */
    p(n = 1) {
      this.d = Math.min(this.k, this.d + n);
    }
    /**
     * Returns the byte index of the given character index in the string. The two
     * may differ in strings that contain multibyte characters.
     */
    f(n = this.d) {
      var t;
      return this.l ? (t = this.A[n]) != null ? t : 1 / 0 : n;
    }
    /**
     * Consumes and returns the given number of characters if possible, advancing
     * the scanner and stopping if the end of the string is reached.
     *
     * If no characters could be consumed, an empty string will be returned.
     */
    G(n = 1) {
      let t = this.m(n);
      return this.p(n), t;
    }
    /**
     * Consumes and returns the given number of bytes if possible, advancing the
     * scanner and stopping if the end of the string is reached.
     *
     * It's up to the caller to ensure that the given byte count doesn't split a
     * multibyte character.
     *
     * If no bytes could be consumed, an empty string will be returned.
     */
    v(n) {
      let t = this.f(), l = this.h.slice(t, t + n);
      return this.p(this.u(l)), l;
    }
    /**
     * Consumes and returns all characters for which the given function returns
     * `true`, stopping when `false` is returned or the end of the input is
     * reached.
     */
    w(n) {
      let { length: t, l, h } = this, f = this.f(), d = f;
      if (l)
        for (; d < t; ) {
          let b = h[d], v = b >= "\uD800" && b <= "\uDBFF";
          if (v && (b += h[d + 1]), !n(b))
            break;
          d += v ? 2 : 1;
        }
      else
        for (; d < t && n(h[d]); )
          ++d;
      return this.v(d - f);
    }
    /**
     * Consumes the given string if it exists at the current character index, and
     * advances the scanner.
     *
     * If the given string doesn't exist at the current character index, an empty
     * string will be returned and the scanner will not be advanced.
     */
    b(n) {
      let { length: t } = n, l = this.f();
      return n === this.h.slice(l, l + t) ? (this.p(t === 1 ? 1 : this.u(n)), n) : p;
    }
    /**
     * Consumes characters until the given global regex is matched, advancing the
     * scanner up to (but not beyond) the beginning of the match. If the regex
     * doesn't match, nothing will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    x(n) {
      let t = this.h.slice(this.f()).search(n);
      return t > 0 ? this.v(t) : p;
    }
    /**
     * Consumes characters until the given string is found, advancing the scanner
     * up to (but not beyond) that point. If the string is never found, nothing
     * will be consumed.
     *
     * Returns the consumed string, or an empty string if nothing was consumed.
     */
    s(n) {
      let t = this.f(), l = this.h.indexOf(n, t);
      return l > 0 ? this.v(l - t) : p;
    }
    /**
     * Returns the given number of characters starting at the current character
     * index, without advancing the scanner and without exceeding the end of the
     * input string.
     */
    m(n = 1) {
      let { d: t, h: l } = this;
      return this.l ? l.slice(this.f(t), this.f(t + n)) : l.slice(t, t + n);
    }
    /**
     * Resets the scanner position to the given character _index_, or to the start
     * of the input string if no index is given.
     *
     * If _index_ is negative, the scanner position will be moved backward by that
     * many characters, stopping if the beginning of the string is reached.
     */
    n(n = 0) {
      this.d = n >= 0 ? Math.min(this.k, n) : Math.max(0, this.d + n);
    }
  }, N = /["&<]/, k = /['&<]/, I = /\r\n|[\n\r\t]/g, xe = /<|&|]]>/, Te = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }));
  function q(n) {
    let t = n.codePointAt(0);
    return t >= 97 && t <= 122 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || t === 45 || t === 46 || t === 183 || t >= 768 && t <= 879 || t === 8255 || t === 8256 || B(n, t);
  }
  function B(n, t = n.codePointAt(0)) {
    return t >= 97 && t <= 122 || t >= 65 && t <= 90 || t === 58 || t === 95 || t >= 192 && t <= 214 || t >= 216 && t <= 246 || t >= 248 && t <= 767 || t >= 880 && t <= 893 || t >= 895 && t <= 8191 || t === 8204 || t === 8205 || t >= 8304 && t <= 8591 || t >= 11264 && t <= 12271 || t >= 12289 && t <= 55295 || t >= 63744 && t <= 64975 || t >= 65008 && t <= 65533 || t >= 65536 && t <= 983039;
  }
  function ke(n) {
    return n === "#" || q(n);
  }
  function Ne(n) {
    let t = n.codePointAt(0);
    return t === 32 || t === 9 || t === 10 || t === 13;
  }
  function z(n) {
    return n >= 32 && n <= 55295 || n === 10 || n === 9 || n === 13 || n >= 57344 && n <= 65533 || n >= 65536 && n <= 1114111;
  }
  var $ = class re {
    constructor() {
      this.parent = null, this.start = -1, this.end = -1;
    }
    /**
     * Document that contains this node, or `null` if this node is not associated
     * with a document.
     */
    get document() {
      var t, l;
      return (l = (t = this.parent) == null ? void 0 : t.document) != null ? l : null;
    }
    /**
     * Whether this node is the root node of the document (also known as the
     * document element).
     */
    get isRootNode() {
      return this.parent !== null && this.parent === this.document && this.type === re.TYPE_ELEMENT;
    }
    /**
     * Whether whitespace should be preserved in the content of this element and
     * its children.
     *
     * This is influenced by the value of the special `xml:space` attribute, and
     * will be `true` for any node whose `xml:space` attribute is set to
     * "preserve". If a node has no such attribute, it will inherit the value of
     * the nearest ancestor that does (if any).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-white-space
     */
    get preserveWhitespace() {
      var t;
      return !!((t = this.parent) != null && t.preserveWhitespace);
    }
    /**
     * Type of this node.
     *
     * The value of this property is a string that matches one of the static
     * `TYPE_*` properties on the `XmlNode` class (e.g. `TYPE_ELEMENT`,
     * `TYPE_TEXT`, etc.).
     *
     * The `XmlNode` class itself is a base class and doesn't have its own type
     * name.
     */
    get type() {
      return "";
    }
    /**
     * Returns a JSON-serializable object representing this node, minus properties
     * that could result in circular references.
     */
    toJSON() {
      let t = {
        type: this.type
      };
      return this.isRootNode && (t.isRootNode = !0), this.preserveWhitespace && (t.preserveWhitespace = !0), this.start !== -1 && (t.start = this.start, t.end = this.end), t;
    }
  };
  $.TYPE_CDATA = "cdata", $.TYPE_COMMENT = "comment", $.TYPE_DOCUMENT = "document", $.TYPE_DOCUMENT_TYPE = "doctype", $.TYPE_ELEMENT = "element", $.TYPE_PROCESSING_INSTRUCTION = "pi", $.TYPE_TEXT = "text", $.TYPE_XML_DECLARATION = "xmldecl";
  var m = $, _ = class extends m {
    constructor(n = "") {
      super(), this.text = n;
    }
    get type() {
      return m.TYPE_TEXT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        text: this.text
      });
    }
  }, F = class extends _ {
    get type() {
      return m.TYPE_CDATA;
    }
  }, R = class extends m {
    constructor(n = "") {
      super(), this.content = n;
    }
    get type() {
      return m.TYPE_COMMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        content: this.content
      });
    }
  }, V = class extends m {
    constructor(n, t, l) {
      super(), this.version = n, this.encoding = t ?? null, this.standalone = l ?? null;
    }
    get type() {
      return m.TYPE_XML_DECLARATION;
    }
    toJSON() {
      let n = m.prototype.toJSON.call(this);
      n.version = this.version;
      for (let t of ["encoding", "standalone"])
        this[t] !== null && (n[t] = this[t]);
      return n;
    }
  }, D = class le extends m {
    constructor(t, l = /* @__PURE__ */ Object.create(null), h = []) {
      super(), this.name = t, this.attributes = l, this.children = h;
    }
    /**
     * Whether this element is empty (meaning it has no children).
     */
    get isEmpty() {
      return this.children.length === 0;
    }
    get preserveWhitespace() {
      let t = this;
      for (; t instanceof le; ) {
        if ("xml:space" in t.attributes)
          return t.attributes["xml:space"] === "preserve";
        t = t.parent;
      }
      return !1;
    }
    /**
     * Text content of this element and all its descendants.
     */
    get text() {
      return this.children.map((t) => "text" in t ? t.text : "").join("");
    }
    get type() {
      return m.TYPE_ELEMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        name: this.name,
        attributes: this.attributes,
        children: this.children.map((t) => t.toJSON())
      });
    }
  }, G = class extends m {
    constructor(n = []) {
      super(), this.children = n;
    }
    get document() {
      return this;
    }
    /**
     * Root element of this document, or `null` if this document is empty.
     */
    get root() {
      for (let n of this.children)
        if (n instanceof D)
          return n;
      return null;
    }
    /**
     * Text content of this document and all its descendants.
     */
    get text() {
      return this.children.map((n) => "text" in n ? n.text : "").join("");
    }
    get type() {
      return m.TYPE_DOCUMENT;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        children: this.children.map((n) => n.toJSON())
      });
    }
  }, H = class extends m {
    constructor(n, t, l, h) {
      super(), this.name = n, this.publicId = t ?? null, this.systemId = l ?? null, this.internalSubset = h ?? null;
    }
    get type() {
      return m.TYPE_DOCUMENT_TYPE;
    }
    toJSON() {
      let n = m.prototype.toJSON.call(this);
      n.name = this.name;
      for (let t of ["publicId", "systemId", "internalSubset"])
        this[t] !== null && (n[t] = this[t]);
      return n;
    }
  }, K = class extends Error {
    constructor(n, t, l) {
      let h = 1, f = "", d = 1;
      for (let X = 0; X < t; ++X) {
        let Z = l[X];
        Z === `
` ? (h = 1, f = "", d += 1) : (h += 1, f += Z);
      }
      let b = l.indexOf(`
`, t);
      f += b === -1 ? l.slice(t) : l.slice(t, b);
      let v = 0;
      f.length > 50 && (h < 40 ? f = f.slice(0, 50) : (v = h - 20, f = f.slice(v, h + 30))), super(
        `${n} (line ${d}, column ${h})
  ${f}
` + " ".repeat(h - v + 1) + `^
`
      ), this.column = h, this.excerpt = f, this.line = d, this.name = "XmlError", this.pos = t;
    }
  }, j = class extends m {
    constructor(n, t = "") {
      super(), this.name = n, this.content = t;
    }
    get type() {
      return m.TYPE_PROCESSING_INSTRUCTION;
    }
    toJSON() {
      return Object.assign(m.prototype.toJSON.call(this), {
        name: this.name,
        content: this.content
      });
    }
  }, Q = "", Ie = class {
    /**
     * @param xml XML string to parse.
     * @param options Parser options.
     */
    constructor(n, t = {}) {
      let l = this.document = new G();
      this.j = l, this.g = t, this.c = new w(n), this.g.includeOffsets && (l.start = 0, l.end = n.length), this.parse();
    }
    /**
     * Adds the given `XmlNode` as a child of `this.currentNode`.
     */
    i(n, t) {
      return n.parent = this.j, this.g.includeOffsets && (n.start = this.c.f(t), n.end = this.c.f()), this.j.children.push(n), !0;
    }
    /**
     * Adds the given _text_ to the document, either by appending it to a
     * preceding `XmlText` node (if possible) or by creating a new `XmlText` node.
     */
    y(n, t) {
      let { children: l } = this.j, { length: h } = l;
      if (n = C(n), h > 0) {
        let f = l[h - 1];
        if (f?.type === m.TYPE_TEXT) {
          let d = f;
          return d.text += n, this.g.includeOffsets && (d.end = this.c.f()), !0;
        }
      }
      return this.i(new _(n), t);
    }
    /**
     * Consumes element attributes.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-starttags
     */
    H() {
      let n = /* @__PURE__ */ Object.create(null);
      for (; this.e(); ) {
        let t = this.q();
        if (!t)
          break;
        let l = this.t() && this.I();
        if (l === !1)
          throw this.a("Attribute value expected");
        if (t in n)
          throw this.a(`Duplicate attribute: ${t}`);
        if (t === "xml:space" && l !== "default" && l !== "preserve")
          throw this.a('Value of the `xml:space` attribute must be "default" or "preserve"');
        n[t] = l;
      }
      if (this.g.sortAttributes) {
        let t = Object.keys(n).sort(), l = /* @__PURE__ */ Object.create(null);
        for (let h = 0; h < t.length; ++h) {
          let f = t[h];
          l[f] = n[f];
        }
        n = l;
      }
      return n;
    }
    /**
     * Consumes an `AttValue` (attribute value) if possible.
     *
     * @returns
     *   Contents of the `AttValue` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that an `AttValue` was consumed but
     *   was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-AttValue
     */
    I() {
      let { c: n } = this, t = n.m();
      if (t !== '"' && t !== "'")
        return !1;
      n.p();
      let l, h = !1, f = Q, d = t === '"' ? N : k;
      e: for (; !n.B; )
        switch (l = n.x(d), l && (this.o(l), f += l.replace(I, " ")), n.m()) {
          case t:
            h = !0;
            break e;
          case "&":
            f += this.C();
            continue;
          case "<":
            throw this.a("Unescaped `<` is not allowed in an attribute value");
          default:
            break e;
        }
      if (!h)
        throw this.a("Unclosed attribute");
      return n.p(), f;
    }
    /**
     * Consumes a CDATA section if possible.
     *
     * @returns Whether a CDATA section was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-cdata-sect
     */
    J() {
      let { c: n } = this, t = n.d;
      if (!n.b("<![CDATA["))
        return !1;
      let l = n.s("]]>");
      if (this.o(l), !n.b("]]>"))
        throw this.a("Unclosed CDATA section");
      return this.g.preserveCdata ? this.i(new F(C(l)), t) : this.y(l, t);
    }
    /**
     * Consumes character data if possible.
     *
     * @returns Whether character data was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dt-chardata
     */
    K() {
      let { c: n } = this, t = n.d, l = n.x(xe);
      if (!l)
        return !1;
      if (this.o(l), n.m(3) === "]]>")
        throw this.a("Element content may not contain the CDATA section close delimiter `]]>`");
      return this.y(l, t);
    }
    /**
     * Consumes a comment if possible.
     *
     * @returns Whether a comment was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Comment
     */
    D() {
      let { c: n } = this, t = n.d;
      if (!n.b("<!--"))
        return !1;
      let l = n.s("--");
      if (this.o(l), !n.b("-->"))
        throw n.m(2) === "--" ? this.a("The string `--` isn't allowed inside a comment") : this.a("Unclosed comment");
      return this.g.preserveComments ? this.i(new R(C(l)), t) : !0;
    }
    /**
     * Consumes a reference in a content context if possible.
     *
     * This differs from `consumeReference()` in that a consumed reference will be
     * added to the document as a text node instead of returned.
     *
     * @returns Whether a reference was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#entproc
     */
    L() {
      let n = this.c.d, t = this.C();
      return t ? this.y(t, n) : !1;
    }
    /**
     * Consumes a doctype declaration if possible.
     *
     * This is a loose implementation since doctype declarations are currently
     * discarded without further parsing.
     *
     * @returns Whether a doctype declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#dtd
     */
    M() {
      let { c: n } = this, t = n.d;
      if (!n.b("<!DOCTYPE"))
        return !1;
      let l = this.e() && this.q();
      if (!l)
        throw this.a("Expected a name");
      let h, f;
      if (this.e()) {
        if (n.b("PUBLIC")) {
          if (h = this.e() && this.N(), h === !1)
            throw this.a("Expected a public identifier");
          this.e();
        }
        if (h !== void 0 || n.b("SYSTEM")) {
          if (this.e(), f = this.r(), f === !1)
            throw this.a("Expected a system identifier");
          this.e();
        }
      }
      let d;
      if (n.b("[")) {
        if (d = n.x(/\][\x20\t\r\n]*>/), !n.b("]"))
          throw this.a("Unclosed internal subset");
        this.e();
      }
      if (!n.b(">"))
        throw this.a("Unclosed doctype declaration");
      return this.g.preserveDocumentType ? this.i(new H(l, h, f, d), t) : !0;
    }
    /**
     * Consumes an element if possible.
     *
     * @returns Whether an element was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-element
     */
    E() {
      let { c: n } = this, t = n.d;
      if (!n.b("<"))
        return !1;
      let l = this.q();
      if (!l)
        return n.n(t), !1;
      let h = this.H(), f = !!n.b("/>"), d = new D(l, h);
      if (d.parent = this.j, !f) {
        if (!n.b(">"))
          throw this.a(`Unclosed start tag for element \`${l}\``);
        this.j = d;
        do
          this.K();
        while (this.E() || this.L() || this.J() || this.F() || this.D());
        let b = n.d, v;
        if (!n.b("</") || !(v = this.q()) || v !== l)
          throw n.n(b), this.a(`Missing end tag for element ${l}`);
        if (this.e(), !n.b(">"))
          throw this.a(`Unclosed end tag for element ${l}`);
        this.j = d.parent;
      }
      return this.i(d, t);
    }
    /**
     * Consumes an `Eq` production if possible.
     *
     * @returns Whether an `Eq` production was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Eq
     */
    t() {
      return this.e(), this.c.b("=") ? (this.e(), !0) : !1;
    }
    /**
     * Consumes `Misc` content if possible.
     *
     * @returns Whether anything was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Misc
     */
    z() {
      return this.D() || this.F() || this.e();
    }
    /**
     * Consumes one or more `Name` characters if possible.
     *
     * @returns `Name` characters, or an empty string if none were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Name
     */
    q() {
      return B(this.c.m()) ? this.c.w(q) : Q;
    }
    /**
     * Consumes a processing instruction if possible.
     *
     * @returns Whether a processing instruction was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-pi
     */
    F() {
      let { c: n } = this, t = n.d;
      if (!n.b("<?"))
        return !1;
      let l = this.q();
      if (l) {
        if (l.toLowerCase() === "xml")
          throw n.n(t), this.a("XML declaration isn't allowed here");
      } else
        throw this.a("Invalid processing instruction");
      if (!this.e()) {
        if (n.b("?>"))
          return this.i(new j(l), t);
        throw this.a("Whitespace is required after a processing instruction name");
      }
      let h = n.s("?>");
      if (this.o(h), !n.b("?>"))
        throw this.a("Unterminated processing instruction");
      return this.i(new j(l, C(h)), t);
    }
    /**
     * Consumes a prolog if possible.
     *
     * @returns Whether a prolog was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-prolog-dtd
     */
    O() {
      let { c: n } = this, t = n.d;
      for (this.P(); this.z(); )
        ;
      if (this.M())
        for (; this.z(); )
          ;
      return t < n.d;
    }
    /**
     * Consumes a public identifier literal if possible.
     *
     * @returns
     *   Value of the public identifier literal minus quotes, or `false` if
     *   nothing was consumed. An empty string indicates that a public id literal
     *   was consumed but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-PubidLiteral
     */
    N() {
      let n = this.c.d, t = this.r();
      if (t !== !1 && !/^[-\x20\r\na-zA-Z0-9'()+,./:=?;!*#@$_%]*$/.test(t))
        throw this.c.n(n), this.a("Invalid character in public identifier");
      return t;
    }
    /**
     * Consumes a reference if possible.
     *
     * This differs from `consumeContentReference()` in that a consumed reference
     * will be returned rather than added to the document.
     *
     * @returns
     *   Parsed reference value, or `false` if nothing was consumed (to
     *   distinguish from a reference that resolves to an empty string).
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-Reference
     */
    C() {
      let { c: n } = this;
      if (!n.b("&"))
        return !1;
      let t = n.w(ke);
      if (n.G() !== ";")
        throw this.a("Unterminated reference (a reference must end with `;`)");
      let l;
      if (t[0] === "#") {
        let h = t[1] === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
        if (isNaN(h))
          throw this.a("Invalid character reference");
        if (!z(h))
          throw this.a("Character reference resolves to an invalid character");
        l = String.fromCodePoint(h);
      } else if (l = Te[t], l === void 0) {
        let {
          ignoreUndefinedEntities: h,
          resolveUndefinedEntity: f
        } = this.g, d = `&${t};`;
        if (f) {
          let b = f(d);
          if (b != null) {
            let v = typeof b;
            if (v !== "string")
              throw new TypeError(`\`resolveUndefinedEntity()\` must return a string, \`null\`, or \`undefined\`, but returned a value of type ${v}`);
            return b;
          }
        }
        if (h)
          return d;
        throw n.n(-d.length), this.a(`Named entity isn't defined: ${d}`);
      }
      return l;
    }
    /**
     * Consumes a `SystemLiteral` if possible.
     *
     * A `SystemLiteral` is similar to an attribute value, but allows the
     * characters `<` and `&` and doesn't replace references.
     *
     * @returns
     *   Value of the `SystemLiteral` minus quotes, or `false` if nothing was
     *   consumed. An empty string indicates that a `SystemLiteral` was consumed
     *   but was empty.
     *
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-SystemLiteral
     */
    r() {
      let { c: n } = this, t = n.b('"') || n.b("'");
      if (!t)
        return !1;
      let l = n.s(t);
      if (this.o(l), !n.b(t))
        throw this.a("Missing end quote");
      return l;
    }
    /**
     * Consumes one or more whitespace characters if possible.
     *
     * @returns Whether any whitespace characters were consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#white
     */
    e() {
      return !!this.c.w(Ne);
    }
    /**
     * Consumes an XML declaration if possible.
     *
     * @returns Whether an XML declaration was consumed.
     * @see https://www.w3.org/TR/2008/REC-xml-20081126/#NT-XMLDecl
     */
    P() {
      let { c: n } = this, t = n.d;
      if (!n.b("<?xml"))
        return !1;
      if (!this.e())
        throw this.a("Invalid XML declaration");
      let l = !!n.b("version") && this.t() && this.r();
      if (l === !1)
        throw this.a("XML version is missing or invalid");
      if (!/^1\.[0-9]+$/.test(l))
        throw this.a("Invalid character in version number");
      let h, f;
      if (this.e()) {
        if (h = !!n.b("encoding") && this.t() && this.r(), h) {
          if (!/^[A-Za-z][\w.-]*$/.test(h))
            throw this.a("Invalid character in encoding name");
          this.e();
        }
        if (f = !!n.b("standalone") && this.t() && this.r(), f) {
          if (f !== "yes" && f !== "no")
            throw this.a('Only "yes" and "no" are permitted as values of `standalone`');
          this.e();
        }
      }
      if (!n.b("?>"))
        throw this.a("Invalid or unclosed XML declaration");
      return this.g.preserveXmlDeclaration ? this.i(new V(
        l,
        h || void 0,
        f || void 0
      ), t) : !0;
    }
    /**
     * Returns an `XmlError` for the current scanner position.
     */
    a(n) {
      let { c: t } = this;
      return new K(n, t.d, t.h);
    }
    /**
     * Parses the XML input.
     */
    parse() {
      if (this.c.b("\uFEFF"), this.O(), !this.E())
        throw this.a("Root element is missing or invalid");
      for (; this.z(); )
        ;
      if (!this.c.B)
        throw this.a("Extra content at the end of the document");
    }
    /**
     * Throws an invalid character error if any character in the given _string_
     * isn't a valid XML character.
     */
    o(n) {
      let { length: t } = n;
      for (let l = 0; l < t; ++l) {
        let h = n.codePointAt(l);
        if (!z(h))
          throw this.c.n(-([...n].length - l)), this.a("Invalid character");
        h > 65535 && (l += 1);
      }
    }
  };
  function C(n) {
    let t = 0;
    for (; (t = n.indexOf("\r", t)) !== -1; )
      n = n[t + 1] === `
` ? n.slice(0, t) + n.slice(t + 1) : n.slice(0, t) + `
` + n.slice(t + 1);
    return n;
  }
  function Ce(n, t) {
    return new Ie(n, t).document;
  }
  return O;
}
var _e = Se();
function De(e) {
  const i = String(e), s = [];
  return { toOffset: a, toPoint: o };
  function o(r) {
    if (typeof r == "number" && r > -1 && r <= i.length) {
      let c = 0;
      for (; ; ) {
        let u = s[c];
        if (u === void 0) {
          const p = te(i, s[c - 1]);
          u = p === -1 ? i.length + 1 : p + 1, s[c] = u;
        }
        if (u > r)
          return {
            line: c + 1,
            column: r - (c > 0 ? s[c - 1] : 0) + 1,
            offset: r
          };
        c++;
      }
    }
  }
  function a(r) {
    if (r && typeof r.line == "number" && typeof r.column == "number" && !Number.isNaN(r.line) && !Number.isNaN(r.column)) {
      for (; s.length < r.line; ) {
        const u = s[s.length - 1], p = te(i, u), g = p === -1 ? i.length + 1 : p + 1;
        if (u === g) break;
        s.push(g);
      }
      const c = (r.line > 1 ? s[r.line - 2] : 0) + r.column - 1;
      if (c < s[r.line - 1]) return c;
    }
  }
}
function te(e, i) {
  const s = e.indexOf("\r", i), o = e.indexOf(`
`, i);
  return o === -1 ? s : s === -1 || s + 1 === o ? o : s < o ? s : o;
}
function je(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? ne(e.position) : "start" in e || "end" in e ? ne(e) : "line" in e || "column" in e ? L(e) : "";
}
function L(e) {
  return ie(e && e.line) + ":" + ie(e && e.column);
}
function ne(e) {
  return L(e && e.start) + "-" + L(e && e.end);
}
function ie(e) {
  return e && typeof e == "number" ? e : 1;
}
class y extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(i, s, o) {
    super(), typeof s == "string" && (o = s, s = void 0);
    let a = "", r = {}, c = !1;
    if (s && ("line" in s && "column" in s ? r = { place: s } : "start" in s && "end" in s ? r = { place: s } : "type" in s ? r = {
      ancestors: [s],
      place: s.position
    } : r = { ...s }), typeof i == "string" ? a = i : !r.cause && i && (c = !0, a = i.message, r.cause = i), !r.ruleId && !r.source && typeof o == "string") {
      const p = o.indexOf(":");
      p === -1 ? r.ruleId = o : (r.source = o.slice(0, p), r.ruleId = o.slice(p + 1));
    }
    if (!r.place && r.ancestors && r.ancestors) {
      const p = r.ancestors[r.ancestors.length - 1];
      p && (r.place = p.position);
    }
    const u = r.place && "start" in r.place ? r.place.start : r.place;
    this.ancestors = r.ancestors || void 0, this.cause = r.cause || void 0, this.column = u ? u.column : void 0, this.fatal = void 0, this.file = "", this.message = a, this.line = u ? u.line : void 0, this.name = je(r.place) || "1:1", this.place = r.place || void 0, this.reason = this.message, this.ruleId = r.ruleId || void 0, this.source = r.source || void 0, this.stack = c && r.cause && typeof r.cause.stack == "string" ? r.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
y.prototype.file = "";
y.prototype.name = "";
y.prototype.reason = "";
y.prototype.message = "";
y.prototype.stack = "";
y.prototype.column = void 0;
y.prototype.line = void 0;
y.prototype.ancestors = void 0;
y.prototype.cause = void 0;
y.prototype.fatal = void 0;
y.prototype.place = void 0;
y.prototype.ruleId = void 0;
y.prototype.source = void 0;
function Xe(e) {
  const i = De(e);
  let s;
  try {
    s = _e.parseXml(String(e), {
      // Positional offsets.
      includeOffsets: !0,
      // `<![CDATA[>&<]]>`
      preserveCdata: !0,
      // `<!--a-->`
      preserveComments: !0,
      // `<!DOCTYPE b>` (a specific declaration)
      preserveDocumentType: !0,
      // `<?xml?>` (a specific instruction)
      preserveXmlDeclaration: !0
    });
  } catch (r) {
    const c = (
      /** @type {XmlError} */
      r
    ), u = i.toPoint(c.pos), p = new y(
      "Could not parse XML with `@rgrove/parse-xml`",
      {
        cause: c,
        place: u,
        ruleId: "error",
        source: "xast-util-from-xml"
      }
    );
    throw p.fatal = !0, p.url = "https://github.com/syntax-tree/xast-util-from-xml#throws", p;
  }
  const o = { location: i }, a = Le(s, o);
  return oe(s, a, o), a;
}
function Oe(e) {
  return { type: "cdata", value: e.text };
}
function Ae(e) {
  return { type: "comment", value: e.content };
}
function Le(e, i) {
  return { type: "root", children: ae(e.children, i) };
}
function Pe(e) {
  return {
    type: "doctype",
    name: e.name,
    public: e.publicId || void 0,
    system: e.systemId || void 0
  };
}
function Me(e, i) {
  const s = ae(e.children, i);
  return {
    type: "element",
    name: e.name,
    attributes: { ...e.attributes },
    // @ts-expect-error: assume content matches.
    children: s
  };
}
function We(e) {
  return { type: "instruction", name: e.name, value: e.content };
}
function Ye(e) {
  return { type: "text", value: e.text };
}
function Ue(e) {
  const i = [];
  return e.version && i.push('version="' + e.version + '"'), e.encoding && i.push('encoding="' + e.encoding + '"'), e.standalone && i.push('standalone="' + e.standalone + '"'), { type: "instruction", name: "xml", value: i.join(" ") };
}
function ae(e, i) {
  const s = [];
  let o = -1;
  for (; ++o < e.length; ) {
    const a = e[o];
    let r;
    a.type === "cdata" ? r = Oe(
      /** @type {XmlCdata} */
      a
    ) : a.type === "comment" ? r = Ae(
      /** @type {XmlComment} */
      a
    ) : a.type === "doctype" ? r = Pe(
      /** @type {XmlDocumentType} */
      a
    ) : a.type === "element" ? r = Me(
      /** @type {XmlElement} */
      a,
      i
    ) : a.type === "pi" ? r = We(
      /** @type {XmlProcessingInstruction} */
      a
    ) : a.type === "text" ? r = Ye(
      /** @type {XmlText} */
      a
    ) : a.type === "xmldecl" && (r = Ue(
      /** @type {XmlDeclaration} */
      a
    )), r && (oe(a, r, i), s.push(r));
  }
  return s;
}
function oe(e, i, s) {
  const o = (
    // Doesn’t practically happen as far as I found, but `-1` is used in the
    // code, so let’s keep it in.
    /* c8 ignore next */
    e.start === -1 ? void 0 : s.location.toPoint(e.start)
  ), a = (
    // Same as above
    /* c8 ignore next */
    e.end === -1 ? void 0 : s.location.toPoint(e.end)
  );
  o && a && (i.position = { start: o, end: a });
}
const ce = [
  "abstract",
  "acknowledgement",
  "affiliation",
  "appendix",
  "article",
  "author",
  "backmatter",
  "biography",
  "book",
  "chapter",
  "colophon",
  "contributor",
  "contributors",
  "copyright",
  "credit",
  "dedication",
  "docinfo",
  "editor",
  "feedback",
  "frontmatter",
  "google",
  "html",
  "index",
  "macros",
  "mathbook",
  "preface",
  "pretext",
  "references",
  "search",
  "shortlicense",
  "solutions",
  "subsection",
  "titlepage",
  "website"
], ue = [
  "assemblage",
  "chapter",
  "conclusion",
  "introduction",
  "objectives",
  "outcomes",
  "paragraphs",
  "part",
  "postlude",
  "prelude",
  "reading-questions",
  "sbsgroup",
  "section",
  "stack",
  "subsection",
  "subsubsection",
  "task",
  "technology",
  "worksheet"
], he = [
  "activity",
  "algorithm",
  "answer",
  "axiom",
  "biblio",
  "blockquote",
  "case",
  "choice",
  "choices",
  "claim",
  "conjecture",
  "console",
  "corollary",
  "definition",
  "demonstration",
  "description",
  "example",
  "exercise",
  "exploration",
  "fact",
  "hint",
  "image",
  "images",
  "insight",
  "interactive",
  "investigation",
  "lemma",
  "list",
  "listing",
  "note",
  "openconjecture",
  "openproblem",
  "openquestion",
  "page",
  "poem",
  "principle",
  "problem",
  "program",
  "project",
  "proof",
  "proposition",
  "question",
  "remark",
  "shortdescription",
  "solution",
  "stanza",
  "statement",
  "subtask",
  "table",
  "tabular",
  "theorem",
  "video",
  "warning",
  "webwork"
], fe = [
  "address",
  "attribution",
  "caption",
  "cline",
  "date",
  "department",
  "description",
  "edition",
  "entity",
  "holder",
  "idx",
  "institution",
  "journal",
  "line",
  "location",
  "minilicense",
  "mrow",
  "personname",
  "pg-macros",
  "pubtitle",
  "subtitle",
  "support",
  "title",
  "usage",
  "volume",
  "year",
  "xi:include"
], Je = ["ol", "ul", "dl"], qe = ["me", "men", "md", "mdn"], pe = [
  "ul",
  "ol",
  "li",
  "p",
  "task",
  "figure",
  "sidebyside",
  "notation",
  "row"
], de = [
  "latex-image-preamble",
  "latex-image",
  "latex-preamble",
  "slate",
  "sage",
  "sageplot",
  "asymptote",
  "macros",
  "prefigure",
  "program",
  "preamble",
  "postamble",
  "input",
  "output",
  "prompt",
  "pre",
  "pg-code",
  "script",
  "tikzpicture",
  "tikz",
  "code",
  "c",
  "cd"
], Be = [
  ...ce,
  ...ue,
  ...he,
  ...pe,
  "xi:include"
], ze = [
  ...ce,
  ...ue,
  ...he,
  ...pe,
  ...qe,
  ...Je
], se = ["p", "li", "fn"], Fe = [
  "title",
  "shorttitle",
  "subtitle",
  "caption",
  "attribution",
  "personname",
  "location",
  "date",
  "edition",
  "entity",
  "support",
  "name",
  "given",
  "family",
  "usage",
  "volume",
  "number",
  "collection-title",
  "page",
  "year",
  "publisher",
  "publisher-place",
  "URL",
  "issued",
  "description",
  "shortdescription",
  "q",
  "premise",
  "response",
  "li",
  "cell"
];
function Re(e) {
  const i = e?.breakLines ?? "some", s = e?.tabSize ?? 2, o = e?.insertSpaces ?? !0, a = e?.breakSentences ?? !1, r = e?.breakLongAttributes ?? !1, c = e?.printWidth ?? 80;
  return { ind: o ? " ".repeat(s) : "	", blankLines: i, breakSentences: a, breakLongAttributes: r, printWidth: c };
}
function me(e, i) {
  const s = Re(i), o = [];
  e.children.length === 1 && e.children[0].type === "element" && e.children[0].name === "tmp-root" && (e = { ...e, children: e.children[0].children });
  for (const r of e.children)
    P(r, o, 0, s);
  const a = Qe(o, s);
  for (; a.length > 0 && a[a.length - 1] === ""; ) a.pop();
  return a.join(`
`);
}
const et = function(e) {
  this.compiler = (i) => me(i, e);
};
function tt(e, i) {
  let s, o = null;
  if (e.startsWith("<?xml")) {
    const r = e.indexOf("?>");
    if (r !== -1) {
      const c = r + 2;
      o = e.slice(0, c), e = e.slice(c);
    }
  }
  e = `<tmp-root>${e}</tmp-root>`;
  try {
    s = Xe(e);
  } catch {
    return console.warn("Input is not well-formed XML; returning original text."), e = e.replace(/<tmp-root>(.*?)<\/tmp-root>/s, "$1"), o && (e = o + `

` + e), e;
  }
  let a = me(s, i);
  return o && (a = o + `

` + a), a;
}
function P(e, i, s, o) {
  switch (e.type) {
    case "instruction":
      i.push(`<?${e.name}${e.value ? " " + e.value : ""}?>`);
      break;
    case "doctype":
      i.push(`<!DOCTYPE ${e.name}>`);
      break;
    case "comment":
      i.push(`${o.ind.repeat(s)}<!--${e.value}-->`);
      break;
    case "cdata":
      i.push(
        `${o.ind.repeat(s)}<![CDATA[${e.value}]]>`
      );
      break;
    case "text": {
      const a = e.value.trim();
      a && i.push(`${o.ind.repeat(s)}${S(a)}`);
      break;
    }
    case "element":
      ge(e, i, s, o);
      break;
  }
}
function ge(e, i, s, o) {
  const a = e.name;
  de.includes(a) ? Ve(e, i, s, o) : Fe.includes(a) ? He(e, i, s, o) : fe.includes(a) ? Ge(e, i, s, o) : se.includes(a) && !Ee(e) ? Ke(e, i, s, o) : se.includes(a) ? be(e, i, s, o) : ye(e, i, s, o);
}
function Ve(e, i, s, o) {
  if (e.children.some((u) => u.type === "element")) {
    ye(e, i, s, o);
    return;
  }
  const a = o.ind.repeat(s);
  if (x(e)) {
    i.push(`${a}${T(e)}`);
    return;
  }
  const r = e.children.map((u) => u.type === "text" ? S(u.value) : u.type === "cdata" ? `<![CDATA[${u.value}]]>` : "").join("");
  if (/\n[ \t]*$/.test(r)) {
    const u = r.replace(/\n[ \t]*$/, `
`);
    i.push(`${a}${E(e)}${u}${a}</${e.name}>`);
  } else
    i.push(`${a}${E(e)}${r}</${e.name}>`);
}
function Ge(e, i, s, o) {
  const a = o.ind.repeat(s);
  if (x(e)) {
    i.push(`${a}${T(e)}`);
    return;
  }
  const r = Y(e.children);
  i.push(`${a}${E(e)}${r}</${e.name}>`);
}
function He(e, i, s, o) {
  const a = o.ind.repeat(s);
  if (x(e)) {
    i.push(`${a}${T(e)}`);
    return;
  }
  if (Ee(e)) {
    be(e, i, s, o);
    return;
  }
  const r = U(e.children), c = o.ind.repeat(s + 1), u = `${a}${E(e)}${r.join(" ")}</${e.name}>`;
  if (o.printWidth === 0 || u.length <= o.printWidth) {
    i.push(u);
    return;
  }
  i.push(`${a}${E(e)}`);
  for (const p of J(r, o.printWidth, c.length, o.breakSentences))
    i.push(`${c}${p}`);
  i.push(`${a}</${e.name}>`);
}
function Ke(e, i, s, o) {
  const a = o.ind.repeat(s), r = o.ind.repeat(s + 1);
  if (x(e)) {
    i.push(`${a}${T(e)}`);
    return;
  }
  i.push(`${a}${E(e)}`);
  const c = U(e.children);
  for (const u of J(c, o.printWidth, r.length, o.breakSentences))
    i.push(`${r}${u}`);
  i.push(`${a}</${e.name}>`);
}
function be(e, i, s, o) {
  const a = o.ind.repeat(s), r = o.ind.repeat(s + 1);
  if (x(e)) {
    i.push(`${a}${T(e)}`);
    return;
  }
  i.push(`${a}${E(e)}`);
  const c = M(e);
  let u = 0;
  for (; u < c.length; )
    if (W(c[u])) {
      const p = c[u];
      u++;
      let g = "";
      if (u < c.length && c[u].type === "text") {
        const N = c[u].value, k = /^(\s*)([.,;:!?])/.exec(N);
        if (k) {
          g = k[2];
          const I = N.slice(k[0].length);
          c[u].value = I, I.trim() || u++;
        }
      }
      const w = [];
      ge(p, w, s + 1, o), g && w.length > 0 && (w[w.length - 1] += g), i.push(...w);
    } else {
      const p = [];
      for (; u < c.length && !W(c[u]); )
        p.push(c[u]), u++;
      const g = U(p);
      if (g.length > 0)
        for (const w of J(g, o.printWidth, r.length, o.breakSentences))
          i.push(`${r}${w}`);
    }
  i.push(`${a}</${e.name}>`);
}
function ye(e, i, s, o) {
  const a = o.ind.repeat(s);
  if (x(e)) {
    i.push(...A(e, s, o, !0));
    return;
  }
  const r = M(e);
  if (r.length === 1 && r[0].type === "element" && r[0].name === "xi:include") {
    const c = r[0], u = A(e, s, o);
    if (u.length === 1) {
      const p = x(c) ? T(c) : `${E(c)}${Y(c.children)}</${c.name}>`;
      i.push(`${u[0]}${p}</${e.name}>`);
      return;
    }
    i.push(...u), P(c, i, s + 1, o), i.push(`${a}</${e.name}>`);
    return;
  }
  i.push(...A(e, s, o));
  for (const c of M(e))
    P(c, i, s + 1, o);
  i.push(`${a}</${e.name}>`);
}
function Qe(e, i) {
  const s = [];
  for (let o = 0; o < e.length; o++) {
    const a = e[o].trim(), r = o < e.length - 1 ? e[o + 1].trim() : null;
    if (s.push(e[o]), o === 0 && /^<\?xml(?:\s|\?>)/.test(a)) {
      s.push("");
      continue;
    }
    if (i.blankLines !== "few")
      if (i.blankLines === "some")
        if (a.startsWith("</") && r !== null && r.startsWith("<")) {
          const c = /^<([^\s>/]+)/.exec(r)?.[1];
          c && Be.includes(c) && s.push("");
        } else /^<title[\s>]/.test(a) && a.includes("</title>") && s.push("");
      else i.blankLines === "many" && (a.startsWith("</") || a.startsWith("<") && r !== null && r.startsWith("<")) && s.push("");
  }
  return s;
}
function Y(e) {
  return e.map((i) => i.type === "text" ? S(i.value) : i.type === "element" ? ve(i) : i.type === "comment" ? `<!--${i.value}-->` : i.type === "cdata" ? `<![CDATA[${i.value}]]>` : "").join("");
}
function ve(e) {
  return x(e) ? T(e) : `${E(e)}${Y(e.children)}</${e.name}>`;
}
function U(e) {
  const i = [];
  for (const s of e)
    if (s.type === "text") {
      const o = s.value.split(/\s+/).filter((a) => a.length > 0);
      for (let a = 0; a < o.length; a++) {
        const r = S(o[a]);
        a === 0 && i.length > 0 && /^[.,;:!?\-]/.test(r) ? i[i.length - 1] += r : i.push(r);
      }
    } else s.type === "element" ? i.push(ve(s)) : s.type === "comment" && i.push(`<!--${s.value}-->`);
  return i;
}
function J(e, i, s, o) {
  if (e.length === 0) return [];
  const a = i === 0 ? 1 / 0 : Math.max(20, i - s), r = [];
  let c = "";
  for (let u = 0; u < e.length; u++) {
    const p = e[u];
    c === "" ? c = p : c.length + 1 + p.length <= a ? c += " " + p : (r.push(c), c = p), o && /[.!?]$/.test(p) && u < e.length - 1 && (r.push(c), c = "");
  }
  return c && r.push(c), r;
}
function E(e) {
  const i = we(e);
  return i ? `<${e.name} ${i}>` : `<${e.name}>`;
}
function T(e) {
  const i = we(e);
  return i ? `<${e.name} ${i}/>` : `<${e.name}/>`;
}
function we(e) {
  return $e(e).join(" ");
}
function $e(e) {
  return Object.entries(e.attributes || {}).map(([i, s]) => s == null ? i : `${i}="${Ze(s)}"`);
}
function A(e, i, s, o = !1) {
  const a = s.ind.repeat(i), r = $e(e), c = o ? "/>" : ">";
  if (r.length === 0)
    return [`${a}<${e.name}${c}`];
  const u = `${a}<${e.name} ${r.join(" ")}${c}`;
  if (!s.breakLongAttributes || s.printWidth === 0 || u.length <= s.printWidth)
    return [u];
  const p = `${a}${" ".repeat(e.name.length + 2)}`, g = [`${a}<${e.name} ${r[0]}`];
  for (const w of r.slice(1))
    g.push(`${p}${w}`);
  return g[g.length - 1] += c, g;
}
function x(e) {
  return e.children.every(
    (i) => i.type === "text" && i.value.trim() === ""
  );
}
function M(e) {
  return e.children.filter(
    (i) => !(i.type === "text" && i.value.trim() === "")
  );
}
function W(e) {
  if (e.type !== "element") return !1;
  const i = e.name;
  return i === "c" ? !1 : (ze.includes(i) || de.includes(i)) && !fe.includes(i);
}
function Ee(e) {
  return e.children.some((i) => W(i));
}
function S(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Ze(e) {
  return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
export {
  ze as blockTags,
  he as docEnvs,
  ue as docSecs,
  ce as docStructure,
  tt as formatPretext,
  fe as lineEndTags,
  Be as newlineTags,
  se as parTags,
  et as pretextFormatPlugin,
  me as serializeXast,
  Fe as smartParTags,
  de as verbatimTags
};
